/** SHA/SHIF/UHC/ECCIF cover on an HMIS patient (cash patients must not file SHA claims). */
export function isShaCoveredPatient(p: any): boolean {
  if (!p || typeof p !== 'object') return false;
  const cr = p.shaBeneficiaryCrId || p.sha_beneficiary_cr_id || p.memberCrNumber;
  if (cr && String(cr).trim()) return true;
  if (p.shifBeneficiary === true || p.shif_beneficiary === true) return true;
  const ins = String(p.insuranceProvider || p.insurance_provider || '').toUpperCase().trim();
  return ['SHA', 'SHIF', 'NHIF', 'UHC', 'ECCIF'].includes(ins);
}

/** Doctor-facing CPOE copy — no S1–S8 codes. */
export function doctorShaCoverageCopy(check: any): { title: string; badge: string | null } {
  if (!check || check.paymentMethod !== 'SHA') {
    return { title: check?.message || 'Cash — not SHA mapped', badge: null };
  }
  if (check.electivePreAuth) {
    return { title: 'SHA intervention requires elective preauthorization', badge: 'Elective preauth' };
  }
  if (check.requiresPreAuth) {
    return { title: 'SHA coverage/preauthorization required', badge: 'Pre-Auth Required' };
  }
  return { title: 'SHA covered — no preauthorization required', badge: null };
}
